/*============================================================================
  Zevorah cart rewards (ported from Impulse to Dawn 16).
  The rewards bar is Liquid (snippets/ln-cart-rewards-bar.liquid) inside the cart drawer
  (.drawer__inner) and cart page (.js-contents). Dawn re-renders those sections on every
  add/change, so the bar content updates without a reload. This script:
  - animates the fill bar from its previous width to the new one after a re-render
  - refreshes a PDP rewards box marked [data-rewards-refreshable] on cart updates
==============================================================================*/
(function () {
  'use strict';

  var lastFillWidth = null;
  var rewardsRefreshInFlight = null;

  function animateFill() {
    var fills = document.querySelectorAll('.cart-rewards__fill[data-fill-target]');
    if (!fills.length) return;
    var target = parseFloat(fills[0].dataset.fillTarget) || 0;
    fills.forEach(function (fill) {
      if (fill.dataset.lnAnimated === String(target)) return;
      fill.dataset.lnAnimated = String(target);
      if (lastFillWidth !== null && lastFillWidth !== target) {
        fill.style.transition = 'none';
        fill.style.width = lastFillWidth + '%';
        void fill.offsetWidth;
        fill.style.transition = '';
        fill.style.width = target + '%';
      }
    });
    lastFillWidth = target;
  }

  function sectionIdFor(el) {
    var withData = el.closest('[data-section-id]');
    if (withData) return withData.getAttribute('data-section-id');
    var section = el.closest('.shopify-section');
    return section && section.id ? section.id.replace(/^shopify-section-/, '') : null;
  }

  function refreshRewardsBox() {
    var currentBox = document.querySelector('[data-rewards-refreshable]');
    if (!currentBox || rewardsRefreshInFlight) return rewardsRefreshInFlight;
    var sectionId = sectionIdFor(currentBox);
    if (!sectionId) return null;

    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    rewardsRefreshInFlight = fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (htmlText) {
        var html = document.createElement('div');
        html.innerHTML = htmlText;
        var nextBox = html.querySelector('[data-rewards-refreshable]');
        var liveBox = document.querySelector('[data-rewards-refreshable]');
        if (nextBox && liveBox) liveBox.replaceWith(nextBox);
      })
      .catch(function () {})
      .finally(function () { rewardsRefreshInFlight = null; });
    return rewardsRefreshInFlight;
  }

  function observe() {
    var targets = document.querySelectorAll('cart-drawer, #main-cart-items');
    targets.forEach(function (t) {
      new MutationObserver(function () { animateFill(); }).observe(t, { childList: true, subtree: true });
    });
    animateFill();
  }

  document.addEventListener('ajaxProduct:added', refreshRewardsBox);
  document.addEventListener('cart:updated', function () { animateFill(); refreshRewardsBox(); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
})();
